module.exports = __webpack_public_path__ + "safari-pinned-tab.svg";